<cc-lazy-host [componentId]="isDevMode ? devLayerComponentId : null" />
